import { render, staticRenderFns } from "./TypeChecklistItemCategoryDialog.vue?vue&type=template&id=74dbf0a8&"
import script from "./TypeChecklistItemCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./TypeChecklistItemCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports